import React from "react";
import { useAttachDocumentMutation } from "../../../features/Incidents/IncidentSlice";
import toast from "react-hot-toast";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import { Loader } from "../Loader/Loader";
import FileUploadForm from "../FileUploadForm/FileUploadForm";

const AttachmentModal = ({ isOpen, toggle, fn }) => {
  const addAttachmentformStructure = {
    pages: [
      {
        name: "attach document",
        elements: [
          {
            type: "text",
            name: "name",
            title: "File Name",
            isRequired: true,
          },
          {
            type: "comment",
            name: "description",
            title: "Description",
            isRequired: true,
          },
          {
            type: "file",
            name: "file",
            title: "File",
            isRequired: true,
            storeDataAsText: false,
            needConfirmRemoveFile: true,
            allowMultiple: false,
            maxSize: 1073741824,
            acceptedTypes:
              ".doc,.docx,.jpeg,.pdf,.mp4,.msg,.ost,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/pdf,video/mp4,application/vnd.ms-outlook",
            description:
              "Please upload a file in one of the supported formats: DOC, DOCX, JPEG, PDF, MP4, MSG, OST.",
          },
        ],
      },
    ],
    widthMode: "responsive",
  };
  const [attachDocument, { isLoading: attachDocumentIsLoading }] =
    useAttachDocumentMutation();

  const handleAddAttachment = async (file, data) => {
    try {
      if (!file) {
        toast.error("Attachment is Required !");
        return;
      }

      const formData = new FormData();
      formData.append("Name", data.name);
      formData.append("Description", data.description);
      formData.append("File", file);

      toggle();

      const response = attachDocument(formData).unwrap();

      toast.promise(response, {
        loading: "Saving Attachment...",
        success: "Attachment Saved",
        error: "Something Went Wrong...!",
      });

      const result = await response;
      if (result?.id) {
        await fn(result?.id);
      }
    } catch (error) {
      toast.error(
        error?.data?.Message ||
          error?.data?.title ||
          "Something unexpected error occ"
      );
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      fade={false}
      backdrop={"static"}
      className=""
      centered
      size="xl"
      scrollable={true}
    >
      <ModalHeader className="border-0" toggle={toggle}>
        Add Attachment
      </ModalHeader>
      <ModalBody>
        {attachDocumentIsLoading ? (
          <Loader />
        ) : (
          <FileUploadForm
            data={addAttachmentformStructure}
            handleSave={handleAddAttachment}
          />
        )}
      </ModalBody>
    </Modal>
  );
};

export default AttachmentModal;
